import { createApi } from "@mattfinkel/common-web";
import { auth } from "../firebase";

export const api = createApi({
  auth,
  baseUrl: import.meta.env.VITE_API_BASE_URL,
  serviceUnavailableMessage: "Feedback service is unavailable. Try again.",
});

export const { warmApi, authedFetch, authedFetchRaw, postJson, putJson } = api;
